import { ChatsStore } from '../ChatsStore'
import { chatsRefresh } from './chatsRefresh'
import { Message } from '@/shared/interfaces/Message'
import { User } from '@/shared/interfaces/User'
import { TimeFormat } from '@/shared/helpers/TimeFormat'
import { decryptIncomingMessage } from '@/shared/crypto/secretMessage'

export async function chatsAddMessageToChat(
  chatId: number,
  message: Message,
  sender: User | null = null,
) {
  const { chatsStore, chatsState } = ChatsStore.get()

  if (!chatsState.chats.filter((s) => s?.id === chatId).length) {
    await chatsRefresh()
    return
  }

  // Секретный чат: расшифровываем сообщение на устройстве до попадания в стор/кэш.
  const targetChat = chatsState.chats.find((s) => s?.id === chatId)
  if (targetChat?.is_secret && targetChat.user?.id) {
    await decryptIncomingMessage(targetChat.user.id, message)
  }

  await chatsStore.addMessageToCache(chatId, message)

  await chatsStore.dispatch(async (state) => {
    const chat = state.chats.filter((s) => s.id === chatId)[0]

    chat.content_last_message = message.content
    chat.dt_departure_last_message = message.dt_departure
    chat.last_message = message

    const isSelectedChat =
      state.selectedChat && chat.id === state.selectedChat.id

    if (!isSelectedChat && sender && sender.id !== state.userId) {
      (chat.number_of_unread_messages as number)++
    }

    // В открытый чат добавляем входящее сразу (и во время подгрузки истории тоже):
    // дубли отсекаются по id ниже, поэтому гейт !areMessagesLoading лишний — из-за
    // него сообщение попадало только в превью списка, а на странице чата
    // появлялось лишь после перезагрузки.
    if (isSelectedChat) {
      let messageGroup = state.messageGroups.filter(
        (s) => s.date === TimeFormat.dayStart(message.dt_departure),
      )[0]

      if (!messageGroup) {
        messageGroup = {
          messages: [],
          date: TimeFormat.dayStart(message.dt_departure),
        }

        state.messageGroups = [messageGroup, ...state.messageGroups]
      }


      if (!messageGroup.messages.filter((s) => s.id === message.id).length) {
        messageGroup.messages = [message, ...messageGroup.messages]
        // Пересобираем массив групп, чтобы гарантированно перерисовать открытый
        // чат и при добавлении в УЖЕ существующую группу дня. Без этого вложенное
        // изменение .messages не всегда триггерило ререндер — сообщение
        // появлялось только в превью списка, а на странице чата — после F5.
        state.messageGroups = [...state.messageGroups]
      }
    }
    state.chats = [chat, ...state.chats.filter((s) => s.id !== chatId)]
  })
}
